import { getThemeProps, type ThemeName } from 'design-system/themes';
import { cn } from 'utils/classNames';

interface Props {
	className?: string;
	theme: ThemeName | undefined;
}

export default function ThemeRibbon({ className, theme = 'base' }: Props) {
	const themeProps = getThemeProps(theme);

	if (!themeProps.ribbonBgClass) {
		return null;
	}

	return <div className={cn('h-4', themeProps.ribbonBgClass, className)} />;
}
ThemeRibbon.displayName = 'ThemeRibbon';
